import NiceModal from '@ebay/nice-modal-react';
import { ActionIcon, Grid, Group, Paper, Text } from '@mantine/core';
import { IconTrash } from '@tabler/icons-react';

import { useGetManagers } from '../../api/getManagers';
import { useRemoveManager } from '../../api/removeManager';
import { Platform } from '../../types';

import { AddModal } from './AddModal';

import { AddButton } from '@/components';
import { ConfirmModal } from '@/components/Modals/Confirm';
import { useDepartmentStore } from '@/stores/department';

type Props = {
  pageId: string;
  platform: Platform;
};

export const Managers = ({ pageId, platform }: Props) => {
  const department = useDepartmentStore((state) => state.selected);
  const { data, isLoading } = useGetManagers({ pageId });
  const removeManager = useRemoveManager({ pageId });
  const { managers = [] } = data || {};

  return (
    <div>
      <Grid columns={3}>
        {managers.map((manager) => (
          <Grid.Col span={1} key={manager._id}>
            <Paper shadow="md" radius="md" p="md">
              <Group justify="space-between">
                <Text size="sm">{manager.username}</Text>
                <ActionIcon
                  variant="filled"
                  onClick={() => {
                    NiceModal.show(ConfirmModal, {
                      title: 'Remove manager?',
                      onSuccess: () => removeManager.mutate({ managerId: manager._id }),
                    });
                  }}
                  radius="md"
                >
                  <IconTrash />
                </ActionIcon>
              </Group>
            </Paper>
          </Grid.Col>
        ))}
      </Grid>
      <AddButton
        isLoading={isLoading}
        onClick={() => NiceModal.show(AddModal, { pageId, platform, department })}
      />
    </div>
  );
};
